import {Breadcrumbs, Link as MatLink, useTheme} from "@mui/material";
import { Link as RouterLink } from 'react-router-dom';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import * as React from "react";
import {
    includesDashboardPowerPlantEquipmentPage,
    includesDashboardPowerPlantSkidEquipmentPage,
    includesSettingsCountryPage,
    includesSettingsProfilesPage,
    isAnalysisPage,
    isCommunicationPage,
    isDashboardOverviewMapPage,
    isDashboardOverviewAlarmsPage,
    isDashboardOverviewSynopticPage,
    isDashboardOverviewActivePowerPage,
    isDashboardOverviewUnavailabilityPage,
    isDashboardPage,
    isDashboardPowerPlantAlarmsPage,
    isDashboardPowerPlantChartsPage,
    isDashboardPowerPlantEquipmentComparePage,
    isDashboardPowerPlantEquipmentDetailsPage,
    isDashboardPowerPlantLayoutPage,
    isDashboardPowerPlantPage,
    isDashboardPowerPlantSkidAlarmsPage,
    isDashboardPowerPlantSkidChartsPage,
    isDashboardPowerPlantSkidEquipmentComparePage,
    isDashboardPowerPlantSkidEquipmentDetailsPage,
    isDashboardPowerPlantSkidEquipmentSimplePage,
    isDashboardPowerPlantSkidLayoutPage,
    isDashboardPowerPlantSKidPage,
    isGraphElementPage,
    isGraphElementFormPage,
    isHelpPage,
    isIncludesAnalysisHomePage,
    isReportsAlarmsPage,
    isReportsAuditPage,
    isReportsEquipmentClassPage,
    isReportsEquipmentPage,
    isReportsManagementReport,
    isReportsPage,
    isReportsPerformanceSummaryPage,
    isReportsPowerPlantPage,
    isReportsSkidPage,
    isReportsTeleobjectPage,
    isSettingsAuditPage,
    isSettingsEquipmentClassFormPage,
    isSettingsEquipmentClassPage,
    isSettingsEquipmentPage,
    isSettingsEquipmentFormPage,
    isSettingsEquipmentTypePage,
    isSettingsEquipmentTypeFormPage,
    isSettingsGraficElementPage,
    isSettingsGraficElementFormPage,
    isSettingsMacroRegionPage,
    isSettingsNotificationGroupFormPage,
    isSettingsNotificationGroupPage,
    isSettingsPage,
    isSettingsPowerPlantPage,
    isSettingsPowerPlantFormPage,
    isSettingsPowerStationExcelPage,
    isSettingsRegionPage,
    isSettingsRegionFormPage,
    isSettingsSkidPage,
    isSettingsUsersPage,
    isSettingsUsersFormPage,
    isSettingsSeverityAlarmPage,
    isSettingsSeverityAlarmFormPage,
    isSettingsBrokerPage,
    isSettingsBrokerFormPage,
    isSettingsTeleObjectPage,
    isSettingsTeleObjectSpecificationTypePage,
    isSettingsTeleObjectSpecificationTypeFormPage,
    isSettingsTeleObjectTypePage,
    isSettingsTeleObjectTypeFormPage,
    isSettingsModBusDataTypePage,
    isSettingsModBusDataTypeFormPage,
    isSettingsModBusObjectTypePage,
    isSettingsModBusObjectTypeFormPage,
    SystemRoutes,
    isDashboardOverviewChartsPage,
    isDashboardPowerPlantInvertersPage,
    isDashboardPowerPlantTrackersPage,
    isSettingsPowerStationUserPage,
    isAuditPage,
    isAuditLoginPage,
    isAuditCommandsPage,
    isAuditAlarmsPage,
    isSettingsStatusColorPage,
    isDashboardOverviewPerformancePage,
    isSettingsTicketPage,
    isSettingsTicketFormPage,
    isSettingsTicketCategoryPage,
    isSettingsTicketCategoryFormPage,
    isSettingsTicketSubCategoryPage,
    isSettingsTicketSubCategoryFormPage, isCommunicationEquipmentsPage, isCommunicationTeleobjectsPage, isDashboardOverviewUnavailabilityFormPage,
    isDashboardDailyReportPage,
    isDashboardPowerPlantBatteriesPage, isDashboardPowerPlantBessDetailPage
} from "../../../../Utils/RouteUtils";
import {useAppSelector} from "../../../../Config/Hooks";
import {getFirstAccessibleSettingsRoute} from "../../../../Utils/SettingsRouteUtils";

export default function DashboardPowerPlantChartsPage() {
    const theme = useTheme();
    const {selectedEquipment, selectedPowerPlant, selectedSkid} = useAppSelector((state) => state.dashboard);
    const account = useAppSelector((state) => state.authentication.account);
    const labelDashboard = (isDashboardPowerPlantPage() || isDashboardPowerPlantBessDetailPage()) ? "Usinas e Equipamentos" : "Visão Geral";
    const settingsDefaultRoute = getFirstAccessibleSettingsRoute(account?.authoritySet ?? []);
    const isNewBreadcrumb = () => {
        return (isDashboardPage() && !isDashboardOverviewPerformancePage()) || isCommunicationEquipmentsPage() || isCommunicationTeleobjectsPage() || isSettingsUsersPage() || isAuditCommandsPage()
    }
    return(
        <Breadcrumbs aria-label="breadcrumb"
                     sx={{ display:{xs: isNewBreadcrumb() && !isDashboardPowerPlantInvertersPage() ? "block" : "none", lg: "block"},
                        '& a': { color: isNewBreadcrumb() && !isDashboardPowerPlantInvertersPage() ? theme.palette.text.primary : 'white' },
                        '& .MuiBreadcrumbs-li:last-child a': { color: isNewBreadcrumb() && !isDashboardPowerPlantInvertersPage() ? theme.palette.primary.main : 'white' },
                    }}
                     style={{ color: isNewBreadcrumb() && !isDashboardPowerPlantInvertersPage() ? "rgba(0.0,0.0,0.0,0.8)" : "white", fontWeight: "normal", fontSize: "1rem",
                     }}
                     separator={
                         <ChevronRightIcon
                             fontSize="small"
                            //  style={{ margin:0 }}
                         />
                     }

        >


            {/* DASHBOARD */}
            {/*FIRST LEVEL*/}
            {(isDashboardPage() && !isDashboardOverviewPerformancePage()) ? <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.DASHBOARD_OVERVIEW}>{labelDashboard}</MatLink> : null}
            {isAnalysisPage() || isIncludesAnalysisHomePage() ? <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.ANALYSIS}>ANALYSIS</MatLink> : null}
            {isCommunicationPage() ? <MatLink component={RouterLink} underline="hover" color="inherit" to={isCommunicationTeleobjectsPage() ? SystemRoutes.COMMUNICATION_TELEOBJECTS : SystemRoutes.COMMUNICATION_SENT_TELECOMMAND}>Comunicação</MatLink> : null}
            {isSettingsPage() ? <MatLink component={RouterLink} underline="hover" color="inherit" to={settingsDefaultRoute}>Settings</MatLink> : null}
            {isReportsPage() ? <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.REPORTS_TELEOBJECTS}>REPORTS</MatLink> : null}
            {isAuditPage() ? <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.AUDIT_COMMANDS}>Auditoria</MatLink> : null}
            {isHelpPage() ? <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.HELP}>HELP</MatLink> : null}

            {/* SECOND LEVEL */}
            {/* Dashboard pages */}
            {/* {isDashboardOverviewPage() ?
                <MatLink underline="hover" color="inherit" href={SystemRoutes.DASHBOARD_OVERVIEW}>Visão Geral</MatLink>
                : null} */}

            {isDashboardDailyReportPage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.DASHBOARD_DAILY_REPORT}>Acompanhamento Diário</MatLink>
                : null}

            {isDashboardOverviewChartsPage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.DASHBOARD_OVERVIEW_CHARTS}>Gráficos</MatLink>
                : null}

            {isDashboardOverviewAlarmsPage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.DASHBOARD_OVERVIEW_ALARMS}>Alarmes</MatLink>
                : null}

            {isDashboardOverviewMapPage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.DASHBOARD_OVERVIEW_MAP}>Mapa</MatLink>
                : null}

            {isDashboardOverviewSynopticPage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.DASHBOARD_OVERVIEW_SYNOPTIC}>Sinóptico</MatLink>
                : null}

            {isDashboardOverviewPerformancePage() ?
                <MatLink component={RouterLink}underline="hover" color="inherit" to={SystemRoutes.DASHBOARD_OVERVIEW_PERFORMANCE}>Performance</MatLink>
                : null}

            {isDashboardOverviewActivePowerPage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.DASHBOARD_OVERVIEW_ACTIVE_POWER}>Potência Ativa</MatLink>
                : null}
            {isDashboardOverviewUnavailabilityPage() ?
                <MatLink underline="hover" color="inherit" href={SystemRoutes.DASHBOARD_OVERVIEW_UNAVAILABILITY}>Indisponibilidade</MatLink>
                : null}

            {isDashboardOverviewUnavailabilityFormPage() ?
            <MatLink underline="hover" color="inherit" href={SystemRoutes.DASHBOARD_OVERVIEW_UNAVAILABILITY_FORM}>Novo Registro</MatLink>
                : null}

            {isDashboardPowerPlantPage() || isDashboardPowerPlantBessDetailPage() ?
                // <MatLink underline="hover" color="inherit" href={SystemRoutes.DASHBOARD_POWER_PLANT_OVERVIEW}>Power Plant</MatLink>
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.DASHBOARD_POWER_PLANT_OVERVIEW}>{selectedPowerPlant?.name}</MatLink>
                : null}

            {isDashboardPowerPlantLayoutPage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.DASHBOARD_POWER_PLANT_LAYOUT}>Planta</MatLink>
                : null}

            {isDashboardPowerPlantTrackersPage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.DASHBOARD_POWER_PLANT_TRACKERS}>Trackers</MatLink>
                : null}

            {isDashboardPowerPlantInvertersPage() ?
                <MatLink underline="hover" component={RouterLink} color="inherit" to={SystemRoutes.DASHBOARD_POWER_PLANT_INVERTER}>Inversor</MatLink>
                : null}

            {isDashboardPowerPlantBatteriesPage() || isDashboardPowerPlantBessDetailPage() ?
                <MatLink underline="hover" component={RouterLink} color="inherit" to={SystemRoutes.DASHBOARD_POWER_PLANT_BATTERIES}>Baterias</MatLink>
                : null}

            {isDashboardPowerPlantBessDetailPage() ?
                <MatLink underline="hover" component={RouterLink} color="inherit" to={window.location.pathname}>Bess</MatLink>
                : null}

            {isDashboardPowerPlantAlarmsPage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.DASHBOARD_POWER_PLANT_ALARMS}>Alarmes</MatLink>
                : null}

            {isDashboardPowerPlantChartsPage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.DASHBOARD_POWER_PLANT_CHARTS}>Gráficos</MatLink>
                : null}

            {isDashboardPowerPlantSKidPage() && !isDashboardPowerPlantSkidEquipmentSimplePage() ?
                // <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.DASHBOARD_POWER_PLANT_SKID}>Skid</MatLink>
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.DASHBOARD_POWER_PLANT_SKID_OVERVIEW}>{selectedSkid.name}</MatLink>
                : null}

            {isDashboardPowerPlantSkidLayoutPage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.DASHBOARD_POWER_PLANT_SKID_LAYOUT}>Planta</MatLink>
                : null}

            {isDashboardPowerPlantSkidAlarmsPage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.DASHBOARD_POWER_PLANT_SKID_ALARMS}>Alarmes</MatLink>
                : null}

            {isDashboardPowerPlantSkidChartsPage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.DASHBOARD_POWER_PLANT_SKID_CHARTS}>Gráficos</MatLink>
                : null}

            {includesDashboardPowerPlantEquipmentPage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.DASHBOARD_POWER_PLANT_EQUIPMENTS_DETAILS}>{selectedEquipment.name}</MatLink>
                : null}

            {includesDashboardPowerPlantSkidEquipmentPage() && !isDashboardPowerPlantSkidEquipmentSimplePage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.DASHBOARD_POWER_PLANT_SKID_EQUIPMENTS_DETAILS}>{selectedEquipment.name}</MatLink>
                : null}

            {isDashboardPowerPlantEquipmentDetailsPage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.DASHBOARD_POWER_PLANT_EQUIPMENTS_DETAILS}>Detalhes</MatLink>
                : null}
            {isDashboardPowerPlantSkidEquipmentDetailsPage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.DASHBOARD_POWER_PLANT_SKID_EQUIPMENTS_DETAILS}>Detalhes</MatLink>
                : null}
            {isDashboardPowerPlantSkidEquipmentSimplePage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.DASHBOARD_POWER_PLANT_INVERTER_SIMPLE}>{`${selectedEquipment.name} | ${selectedSkid.name}`}</MatLink>
                : null}

            {isDashboardPowerPlantEquipmentComparePage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.DASHBOARD_POWER_PLANT_EQUIPMENTS_COMPARE}>Comparar</MatLink>
                : null}

            {isDashboardPowerPlantSkidEquipmentComparePage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.DASHBOARD_POWER_PLANT_SKID_EQUIPMENTS_COMPARE}>Comparar</MatLink>
                : null}

            {isCommunicationEquipmentsPage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit"
                         to={SystemRoutes.COMMUNICATION_INHIBIT_EQUIPMENTS}>Inibe/Habilita Equipamentos</MatLink>
                : null}
            {isCommunicationTeleobjectsPage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit"
                         to={SystemRoutes.COMMUNICATION_TELEOBJECTS}>Inibe/Habilita Teleobjetos</MatLink>
                : null}


            {/*Settings pages */}
            {includesSettingsCountryPage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.SETTINGS_COUNTRY}>Country</MatLink>
                : null}
            {isSettingsMacroRegionPage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.SETTINGS_MACRO_REGION}>Macro Region</MatLink>
                : null}
            {isSettingsRegionPage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.SETTINGS_REGION}>Região</MatLink>
                : null}
            {isSettingsRegionFormPage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.SETTINGS_REGION_FORM}>Região Formulário</MatLink>
                : null}
            {isSettingsEquipmentTypePage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.SETTINGS_EQUIPMENT_TYPE}>Tipo de Equipamento</MatLink>
                : null}
            {isSettingsEquipmentTypeFormPage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.SETTINGS_EQUIPMENT_TYPE_FORM}>Tipo de Equipamento Formulário</MatLink>
                : null}
            {isSettingsGraficElementPage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.SETTINGS_GRAFIC_ELEMENT}>Grafic Element</MatLink>
                : null}
            {isSettingsGraficElementFormPage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.SETTINGS_GRAFIC_ELEMENT_FORM}>Grafic Element Formulário</MatLink>
                : null}
            {isSettingsPowerStationExcelPage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.SETTINGS_POWER_STATION_EXCEL}>Usina via Excel</MatLink>
                : null}
            {isGraphElementPage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.SETTINGS_GRAPH_ELEMENT}>Unifilar</MatLink>
                : null}
            {isGraphElementFormPage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.SETTINGS_GRAPH_ELEMENT_FORM}>Unifilar Formulário</MatLink>
                : null}
            {isSettingsEquipmentClassPage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.SETTINGS_EQUIPMENT_CLASS}>Classe de Equipamento</MatLink>
                : null}
            {isSettingsEquipmentClassFormPage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.SETTINGS_EQUIPMENT_CLASS}>Classe de Equipamento Formulário</MatLink>
                : null}
            {isSettingsEquipmentPage() && (!isSettingsEquipmentTypePage() && !isSettingsEquipmentClassPage())?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.SETTINGS_EQUIPMENT}>Equipamento</MatLink>
                : null}

            {isSettingsEquipmentFormPage() && (!isSettingsEquipmentTypePage() && !isSettingsEquipmentClassPage())?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.SETTINGS_EQUIPMENT_FORM}>Equipamento Formulário</MatLink>
                : null}

            {isSettingsSkidPage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.SETTINGS_SKID}>Skid</MatLink>
                : null}
            {isSettingsNotificationGroupPage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.SETTINGS_NOTIFICATION_GROUP}>Grupo de Notificações</MatLink>
                : null}
            {isSettingsNotificationGroupFormPage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.SETTINGS_NOTIFICATION_GROUP_FORM}>Notificações</MatLink>
                : null}
            {isSettingsPowerPlantPage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.SETTINGS_POWER_PLANT}>Usina</MatLink>
                : null}
            {isSettingsPowerPlantFormPage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.SETTINGS_POWER_PLANT}>Usina Formulário</MatLink>
                : null}
            {includesSettingsProfilesPage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.SETTINGS_PROFILE}>Permissões</MatLink>
                : null}
            {isSettingsUsersPage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.SETTINGS_USERS}>Usuários</MatLink>
                : null}
            {isSettingsUsersFormPage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.SETTINGS_USERS_FORM}>Cadastro de Usuários</MatLink>
                : null}
            {isSettingsAuditPage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.SETTINGS_AUDIT}>Audit</MatLink>
                : null}

            {isSettingsSeverityAlarmPage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.SETTINGS_ALARM_SEVERITY}>Severidade do Alarme</MatLink>
                : null}

            {isSettingsStatusColorPage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.SETTINGS_STATUS_COLOR}>Cores de Status</MatLink>
            : null}

            {isSettingsSeverityAlarmFormPage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.SETTINGS_ALARM_SEVERITY_FORM}>Severidade do Alarme Formulário</MatLink>
                : null}

            {isSettingsBrokerPage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.SETTINGS_BROKER}>Broker</MatLink>
                : null}

            {isSettingsBrokerFormPage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.SETTINGS_BROKER_FORM}>Broker Formulário</MatLink>
                : null}

            {isSettingsTeleObjectPage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.SETTINGS_BROKER_FORM}>Teleobjeto</MatLink>
                : null}

            {isSettingsTeleObjectSpecificationTypePage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.SETTINGS_TELE_OBJECT_SPECIFICATION_TYPE}>Especificação de Teleobjeto</MatLink>
                : null}

            {isSettingsTeleObjectSpecificationTypeFormPage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.SETTINGS_TELE_OBJECT_SPECIFICATION_TYPE_FORM}>Especificação de Teleobjeto Formulário</MatLink>
                : null}

            {isSettingsTeleObjectTypePage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.SETTINGS_TELE_OBJECT_TYPE}>Tipo de Teleobjeto</MatLink>
                : null}

            {isSettingsTeleObjectTypeFormPage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.SETTINGS_TELE_OBJECT_TYPE_FORM}>Tipo de Teleobjeto Formulário</MatLink>
                : null}

            {isSettingsModBusDataTypePage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.SETTINGS_MOD_BUS_DATA_TYPES}>Tipo de Dado</MatLink>
                : null}

            {isSettingsModBusDataTypeFormPage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.SETTINGS_MOD_BUS_DATA_TYPES_FORM}>Tipo de Dado Formulário</MatLink>
                : null}

            {isSettingsModBusObjectTypePage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.SETTINGS_MOD_BUS_OBJECTS_TYPES}>Tipos de Objeto</MatLink>
                : null}

            {isSettingsModBusObjectTypeFormPage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.SETTINGS_MOD_BUS_OBJECTS_TYPES_FORM}>Tipos de Objeto Formulário</MatLink>
                : null}

            {isSettingsPowerStationUserPage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.SETTINGS_POWER_STATION_USER}>Acesso de Usinas</MatLink>
                : null}

            {isSettingsTicketPage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.SETTINGS_TICKET}>Ticket</MatLink>
                : null}

            {isSettingsTicketFormPage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.SETTINGS_TICKET_FORM}>Ticket Formulário</MatLink>
                : null}

            {isSettingsTicketCategoryPage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.SETTINGS_TICKET_CATEGORY}>Ticket Categoria</MatLink>
                : null}

            {isSettingsTicketCategoryFormPage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.SETTINGS_TICKET_CATEGORY_FORM}>Ticket Categoria Formulário</MatLink>
                : null}

            {isSettingsTicketSubCategoryPage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.SETTINGS_TICKET_SUBCATEGORY}>Ticket SubCategoria</MatLink>
                : null}

            {isSettingsTicketSubCategoryFormPage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.SETTINGS_TICKET_SUBCATEGORY_FORM}>Ticket SubCategoria Formulário</MatLink>
                : null}

            Reports page
            {isReportsAlarmsPage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.REPORTS_ALARMS}>Alarms</MatLink>
                : null}
            {isReportsPerformanceSummaryPage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.REPORTS_PERFORMANCE_SUMMARY}>Performance Summary</MatLink>
                : null}
            {isReportsPowerPlantPage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.REPORTS_POWER_PLANTS}>Usina</MatLink>
                : null}
            {isReportsManagementReport() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.REPORTS_MANAGEMENT_REPORT}>Relatório de Gestão</MatLink>
                : null}
            {isReportsEquipmentClassPage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.REPORTS_EQUIPMENT_CLASS}>Classes de Equipamento</MatLink>
                : null}
            {isReportsEquipmentPage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.REPORTS_EQUIPMENT}>Equipment</MatLink>
                : null}
            {isReportsSkidPage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.REPORTS_SKID}>Skid</MatLink>
                : null}
            {isReportsTeleobjectPage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.REPORTS_TELEOBJECTS}>Relatório de Telemedidas</MatLink>
                : null}
            {isReportsAuditPage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.REPORTS_AUDIT}>Auditoria</MatLink>
                : null}
            {/*Audit pages */}
            {isAuditLoginPage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.AUDIT_LOGIN}>Login</MatLink>
                : null}
            {isAuditCommandsPage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.AUDIT_COMMANDS}>Auditoria de Comandos</MatLink>
                : null}
            {isAuditAlarmsPage() ?
                <MatLink component={RouterLink} underline="hover" color="inherit" to={SystemRoutes.AUDIT_ALARMS}>Alarmes</MatLink>
                : null}
        </Breadcrumbs>
    );
}
